import { render, staticRenderFns } from "./OficinaReferencia.vue?vue&type=template&id=7e6bbc70&scoped=true&"
import script from "./OficinaReferencia.vue?vue&type=script&lang=js&"
export * from "./OficinaReferencia.vue?vue&type=script&lang=js&"
import style0 from "./OficinaReferencia.vue?vue&type=style&index=0&id=7e6bbc70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6bbc70",
  null
  
)

export default component.exports